;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.blogDetailHeader = (function () {
    const initialize = function () {
      $(window).on('load', function () {
        const $blogDetail = $('.blog .blogPost .postContent')
        if ($blogDetail.length > 0) {
          $blogDetail.find('.wp-caption').each(function (index, el) {
            const $el = $(el)
            if ($el.find('.size-full, .size-large').length > 0) {
              $(el).css('width', 'auto')
            }
          })
        }

        if ($('header.masthead.blog-detail').length) {
          if (Modernizr.mq('(min-width: 58.75em)')) {
            // console.log("Blog Post width: " + $('.blogPost').width());
            // console.log("Time string width: " + $('.blogPost time').outerWidth(true));
            $('.blogCategories').width($('.blogPost').width() - $('.blogPowst time').outerWidth(true) - 15)
          } else {
            $('.blogCategories').width('auto')
          }

          $(window).resize(function () {
            if (Modernizr.mq('(min-width: 58.75em)')) {
              // console.log("Blog Post width: " + $('.blogPost').width());
              // console.log("Time string width: " + $('.blogPost time').outerWidth(true));
              $('.blogCategories').width($('.blogPost').width() - $('.blogPost time').outerWidth(true) - 5)
            } else {
              $('.blogCategories').width('auto')
            }
          })
        }
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.blogDetailHeader.initialize()
  })
}(jQuery, window))
